import styled from 'styled-components';
import { vars, pxToRem, media } from '$util/theme';
import Section from '$components/layout/Section';

export default styled(Section)`
  .container {
    text-align: center;
    padding: 60px 0 80px 0;
    > header {
      font-weight: ${vars.fontWeight.semiLight};
      .title {
        font-size: ${pxToRem(28)};
        ${media.up('md')} {
          font-size: ${pxToRem(32)};
        }
      }
      p {
        margin: 20px auto 50px auto;
        font-size: ${pxToRem(18)};
        ${media.up('md')} {
          font-size: ${pxToRem(24)};
        }
        strong {
          font-weight: ${vars.fontWeight.bold};
        }
      }
    }
    > article {
      max-width: 776px;
      margin: auto;
      border: 1px solid ${vars.quantumverse.reskinColors.brandLightGray};
      border-radius: ${vars['border-radius-base']};
      padding: 16px;
      ${media.up('md')} {
        padding: 40px;
      }
      > header {
        img {
          width: 147px;
        }
        > div {
          font-size: ${pxToRem(22)};
          ${media.up('md')} {
            font-size: ${pxToRem(32)};
          }
          font-weight: ${vars.fontWeight.light};
          margin: 10px 0 20px 0;
          strong {
            font-weight: ${vars.fontWeight.semiBold};
          }
        }
      }
      > .content {
        > p {
          font-size: ${pxToRem(15)};
        }
        > ol {
          counter-reset: getaround-counter;
          display: inline-block;
          margin: 0;
          padding: 0;
          list-style: none;
          text-align: left;
          font-size: ${pxToRem(14)};
          font-weight: ${vars.fontWeight.bold};
          color: ${vars.quantumverse.reskinColors.purple500};
          ${media.up('md')} {
            font-size: ${pxToRem(17)};
          }
          > li {
            counter-increment: getaround-counter;
            position: relative;
            &:before {
              content: counter(getaround-counter);
              display: inline-block;
              width: 70px;
              height: 70px;
              margin-right: 10px;
              padding: 25px;
              vertical-align: middle;
              background: url('https://res.cloudinary.com/fxtr/image/upload/v1623766261/landing/nut_withborder_xbohof.svg')
                no-repeat;
              background-size: contain;
              background-position: center;
              line-height: 1;
              font-size: 22px;
              font-weight: ${vars.fontWeight.regular};
              text-align: center;
            }
          }
        }
      }
      > footer {
        margin-top: 40px;
        .btn-primary {
          margin: auto;
          max-width: 250px;
          > span {
            margin: auto;
            font-size: ${pxToRem(18)};
          }
        }
      }
    }
  }
`;
